import React from 'react';
import Avatar from 'components/Avatar';
import Pill from 'components/Pill';
import { jsx as _jsx } from "react/jsx-runtime";
export default function SharedByPill(_ref) {
  var pictureUrl = _ref.pictureUrl,
    children = _ref.children;
  return /*#__PURE__*/_jsx(Pill, {
    iconRenderer: function iconRenderer() {
      return pictureUrl ? /*#__PURE__*/_jsx(Avatar, {
        scale: 0.7,
        pictureUrl: pictureUrl
      }) : null;
    },
    children: children
  });
}